"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamMessageTemplatesEntities = exports.getTeamMessageTemplatesNames = exports.getTeamMessageTemplatesByName = exports.getTeamMessageTemplatesAll = exports.getIsTeamMessageTemplatesRejected = exports.getIsTeamMessageTemplatesFulfilled = exports.getIsTeamMessageTemplatesPending = exports.getIsTeamMessageTemplatesIdle = exports.getTeamMessageTemplatesTeamId = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _teamMessageTemplates = require("./teamMessageTemplates.reducer");

var getTeamMessageTemplatesState = function getTeamMessageTemplatesState(state) {
  return state.modules.campaignSettings.entities.teamMessageTemplates;
};

var selectors = _teamMessageTemplates.teamMessageTemplatesAdapter.getSelectors(getTeamMessageTemplatesState);

var getTeamMessageTemplatesTeamId = (0, _ramda.pipe)(getTeamMessageTemplatesState, (0, _ramda.prop)('teamId'));
exports.getTeamMessageTemplatesTeamId = getTeamMessageTemplatesTeamId;
var getTeamMessageTemplatesStatus = (0, _ramda.pipe)(getTeamMessageTemplatesState, (0, _ramda.prop)('status'));
var getIsTeamMessageTemplatesIdle = (0, _ramda.pipe)(getTeamMessageTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Idle));
exports.getIsTeamMessageTemplatesIdle = getIsTeamMessageTemplatesIdle;
var getIsTeamMessageTemplatesPending = (0, _ramda.pipe)(getTeamMessageTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Pending));
exports.getIsTeamMessageTemplatesPending = getIsTeamMessageTemplatesPending;
var getIsTeamMessageTemplatesFulfilled = (0, _ramda.pipe)(getTeamMessageTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Fulfilled));
exports.getIsTeamMessageTemplatesFulfilled = getIsTeamMessageTemplatesFulfilled;
var getIsTeamMessageTemplatesRejected = (0, _ramda.pipe)(getTeamMessageTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Rejected));
exports.getIsTeamMessageTemplatesRejected = getIsTeamMessageTemplatesRejected;
var getTeamMessageTemplatesAll = selectors.getAll,
    getTeamMessageTemplatesByName = selectors.getById,
    getTeamMessageTemplatesNames = selectors.getIds,
    TeamMessageTemplatesEntities = selectors.getEntities;
exports.TeamMessageTemplatesEntities = TeamMessageTemplatesEntities;
exports.getTeamMessageTemplatesNames = getTeamMessageTemplatesNames;
exports.getTeamMessageTemplatesByName = getTeamMessageTemplatesByName;
exports.getTeamMessageTemplatesAll = getTeamMessageTemplatesAll;